import $ from 'jquery';
import '../jquery-plugins/jquery.shuffle-children.js';

// import mpro from './mpro.init';
import MpModal from '../../modules/components/modal.js';
import MpDrawer from '../../modules/components/drawer.js';
// import RemoteAction from '../jquery-plugins/jquery.remote-action.js';

import { loadPartial } from '../../remote/partial-content.js';
import { triggerEvent } from '../../util/dom.js';
import { decodeObjectKeywords, getElementUrl, setElementUrl, setFieldValue } from '../../util/custom.js';
import { doFetch } from '../../remote/request.js';
import { cancelableDelay } from '../../util/event-loop.js';
// import { handleFormChangeWidgets, processFormChangeWidgets } from './mpro.form-change-handlers.js';
import { handleRemoteResponse } from '../../remote/remote-response.js';
import { formWidgetsChangeHandler } from './form/toggle-widgets.js';
import { nl2br } from '../../util/text.js';

// TODO: move this somewhere else
/**
 * Submit a page form or a virtual form
 *
 * @param {string | HTMLFormElement | object} queryForm
 * @param {{ extraData?: URLSearchParams | FormData | object; delay?: number; triggerElement?: HTMLElement | JQuery, removeEmptyParams?: boolean; state?: object }} options
 */
// eslint-disable-next-line require-await
export const submitForm = async (queryForm, options = {}) => {

	const {
		extraData,
		delay,
		triggerElement,
		removeEmptyParams = false,
		state = {},
	} = options;

	if (delay > 0) {
		return new Promise((resolve) => {

			// Delete the delay from options
			delete options.delay;

			let { submitThrottleTimer } = state;
			// Cancel the previous throttle timer
			if (submitThrottleTimer) {
				submitThrottleTimer.cancel();
			}
			submitThrottleTimer = cancelableDelay(Number(delay));
			submitThrottleTimer.then(() => {
				delete state.submitThrottleTimer;
				resolve();
			});
			state.submitThrottleTimer = submitThrottleTimer;
		}).then(() => submitForm(queryForm, options));
	}

	/** @type JQuery<HTMLFormElement> */
	let $form;
	let isVirtual = false;
	let extraCleanup = [];

	// Get form from selector
	if (typeof queryForm === 'string') {
		$form = $(queryForm);
		// Get the current form element or the closest
		if (!$form.is('form')) {
			$form = $form.closest('form');
		}
	}
	// Get form from element
	else if (queryForm instanceof HTMLFormElement) {
		// @ts-ignore
		$form = $(queryForm);
	}
	// Object provided - create a virtual form object
	else if (queryForm) {
		// @ts-ignore
		$form = $(document.createElement('form'));
		// Add all attributes and hive the form
		$form.attr(queryForm).hide();
		const form = $form[0];
		isVirtual = true;

		// Set default action
		if (!form.action) {
			form.action = document.URL;
		}

		// Set default method
		if (!form.method) {
			form.method = 'GET';
		}

		// Put extra url params as form inputs
		if (form.method.toUpperCase() === 'GET') {

			// Rebuild the form action
			const submitUrl = new URL(form.action, document.URL);

			// Append all url params as hidden inputs
			for (const [name, value] of submitUrl.searchParams.entries()) {
				$('<input>').attr({ type: 'hidden', name, value }).appendTo($form);
			}

			// Assign the the new action without params
			form.action = submitUrl.pathname;
		}

		// Add the form to the doc
		mpro.get$B().append($form);
	}

	/**
	 * @param {JQuery<HTMLFormElement>} $form
	 * @param {string[][] | JQuery} entries
	 * @param {boolean} prepareCleanup
	 */
	const appendEntriesToForm = ($form, entries, prepareCleanup) => {

		if (entries instanceof $) {
			// @ts-ignore
			entries = entries.serializeArray().map(({ name, value }) => [name, value]);
		}

		// Append element params
		// @ts-ignore
		for (const [name, value] of entries) {

			// @ts-ignore
			if (value instanceof Blob) {
				console.warn('Blob values are not supported in dynamic form submission (field: %s, value: %s)', name, value);
				continue;
			}

			const $existingInput = $form.find(`[name="${name}"]`);
			const modeAppend = name.endsWith('[]');

			if (modeAppend) {
				if (!removeEmptyParams || (value !== '')) {
					const $el = $('<input>').attr({ type: 'hidden', name, value }).appendTo($form);
					prepareCleanup && extraCleanup.push(() => $el.remove());
				}
			}
			else {
				// Remove empty params
				if (removeEmptyParams && (value === '')) {
					$existingInput.removeAttr('name');
					prepareCleanup && extraCleanup.push(() => $existingInput.attr('name', name));
				}
				else {
					if ($existingInput.length > 0) {
						const prevValue = $existingInput.val();
						$existingInput.val(value);
						prepareCleanup && extraCleanup.push(() => $existingInput.val(prevValue));
					}
					else {
						const $el = $('<input>').attr({ type: 'hidden', name, value }).appendTo($form);
						prepareCleanup && extraCleanup.push(() => $el.remove());
					}
				}
			}
		}
	};

	// Get form data from the trigger element and add it to the form
	if (triggerElement) {
		appendEntriesToForm($form, $(triggerElement), true);
	}

	// Add extra data to the form
	if (extraData) {
		appendEntriesToForm($form, Object.entries(extraData), false);
	}

	// TODO: disable the submitter? (disabling the button will prevent if from being sent with the form)

	// Simulate the requestSubmit method (buggy on some older Safari versions, so we use a custom implementation)
	if ($form.length > 0) {

		// Delete the form on submit (it prevents navigation back issues)
		if (isVirtual) {
			$form.one('submit', (e) => {
				setTimeout(() => $form.remove());
				extraCleanup = [];
			});
		}
		// Revert the form to its original state
		else if (extraCleanup.length > 0) {
			$form.one('submit', (e) => {
				while (extraCleanup.length > 0) {
					extraCleanup.pop()();
				}
			});
		}

		/** @type {HTMLButtonElement|HTMLInputElement} */
		// @ts-ignore
		let submitter = $form.find('button:not([type="button"],[type="reset"]),input[type="submit"]').not(':disabled')[0];

		if (!submitter) {
			submitter = document.createElement('input');
			submitter.type = 'submit';
			submitter.hidden = true;
			$form.append(submitter);
			submitter.click();
			submitter.remove();
		}
		else {
			submitter.click();
		}
	}
	else {
		console.error('[submitForm]: No form found to submit (queryForm: %o)', queryForm);
	}
};

/**
 * @param {string} type
 * @param {string | URL} url
 * @param {string} method
 * @param {any} data
 * @param {HTMLElement} relatedTarget
 * @param {any=} extra
 */
const triggerSubmitNotifyEvent = (type, url, method, data, relatedTarget, extra) => {
	// Trigger the 'mp-ajax-submit-success' event
	mpro.get$D().trigger(new $.Event(`mp-ajax-submit-${type}`, {
		detail: {
			url,
			method,
			data,
			relatedTarget,
			extra,
		},
		cancelable: false,
	}));
};

/**
 * @param {HTMLElement} element
 */
const handleSetFieldsChange = (element) => {

	const $elem = $(element);
	const elemType = $elem[0].nodeName;

	/** @param {*} setFields */
	const doSetFields = (setFields) => {
		for (const [fieldId, fieldValue] of Object.entries(setFields)) {
			// Must defer the set-value call because of the mp-widget-reload event that is triggered next
			window.setTimeout(() => {
				$(`#${fieldId}`).val(fieldValue).trigger('change');
			});
		}
	};

	// Add change handler to handle the setFields data attribute
	$elem.on('change.setFieldsChangeHandler', () => {

		// Handle selects
		if (elemType === 'SELECT') {

			// Get selected options
			const $selected = $elem.find('option').filter(':selected');

			$selected.each(function() {
				const $option = $(this);
				const setFields = $option.data('setFields');

				if (setFields) {
					doSetFields(setFields);
				}
			});
		}
		// Inputs / Textarea
		else {
			const changeSetFields = $elem.data('changeSetFields');

			if (changeSetFields) {
				const { setFields, value } = changeSetFields;

				// Change only if the input text matches the value
				if (setFields && (value === $elem.val()) && setFields) {
					doSetFields(setFields);
				}
			}
		}
	});
};

/**
 * @param {HTMLSelectElement} select
 */
const handleSelectRemote = (select) => {

	const $elem = $(select);

	// Remote-action logic
	handleRemoteAction($elem);
};

/**
 * @param {HTMLInputElement} input
 */
const handleInputRemote = (input) => {

	const $elem = $(input);

	// Remote-action logic
	handleRemoteAction($elem);
};

/**
 * @param {JQuery} $elem
 * @param {{ $defaultOptions?: JQuery<HTMLOptionElement> }} opt
 */
const handleRemoteAction = ($elem, opt = {}) => {

	const data = $elem.data();
	const elemType = $elem[0].nodeName;
	const url = data.remoteUrl;
	let { $defaultOptions } = opt;

	if (!url) {
		console.warn('Missing data-remote-url value for element', this);
		return;
	}

	// Save the default options
	if ((elemType === 'SELECT') && !$defaultOptions?.length) {
		$defaultOptions = $elem.find('option').filter(function() {
			return !this.value;
		});
	}

	// Remote action handler
	const remoteAction = () => {
		const args = data.remoteArgs || {};
		const params = {};

		// Get params from form elements
		if (args) {
			for (const v of Object.keys(args)) {

				// 'fields' is a special parameter, no selector, send as is
				if (v === 'fields') {
					params[v] = args[v];
				}
				// Rest of the args have the id selector
				else {
					/** @type {string[]} */
					const arg = Array.isArray(args[v]) ? args[v] : [args[v]];
					params[v] = arg.map(v => $(`#${v}`).val()).join(',');
				}
			}
		}

		// Abort the previous request
		if (data.ref && data.ref.abort) {
			data.ref.abort();
		}

		// Assign the abort method on a ref object on the element's data
		data.ref = {};

		doFetch(url, { data: params }, { ref: data.ref, cache: true })
			.then((/** @type {{id: number|string; text: string; setFields?: any}[]} */ values) => {

				// Handle select
				if (elemType === 'SELECT') {
					const options = [];
					for (const val of values) {
						const $option = $(new Option(val.text, String(val.id), false, false));
						options.push($option);

						// Auto-set field values
						if (val.setFields) {
							$option.data('setFields', val.setFields);
						}
					}

					$elem.empty().append($defaultOptions).append(options);
				}
				// Handle input
				else if (elemType === 'INPUT') {
					for (const val of values) {

						// Force new input text
						if (val.text != null) {
							$elem.val(val.text);
						}

						// Auto-set field values
						if (val.setFields) {
							// Assign the changeSetFields to element data so we can process them in the other handler
							$elem.data('changeSetFields', { value: $elem.val(), setFields: val.setFields });
							// This is not needed if proper handler order is ensured (the setFieldsChangeHandler must be assigned last)
							$elem.triggerHandler('change.setFieldsChangeHandler');
						}
						// Remove the changeSetFields so there are no side-effects
						else {
							$elem.data('changeSetFields', null);
						}
					}
				}
			})
			.catch((error) => {
				console.log('err %o', error);
			})
			.finally(() => {
				// Discard the data ref object
				data.ref = null;
			});
	};

	// Create a throttle function
	const throttledRemoteAction = (e) => {

		let delay = 233;

		if (e) {
			switch (e.type) {

				case 'mp-widget-reload': {
					e.stopPropagation();
					delay = 233;
					break;
				}

				case 'change': {
					delay = 100;
					break;
				}

				case 'input': {
					delay = 633;
					break;
				}
			}
		}

		data.remoteThrottleTimer && window.clearTimeout(data.remoteThrottleTimer);
		data.remoteThrottleTimer = window.setTimeout(remoteAction, delay);
	};

	// Execute the action on init
	// Not a good idea because on post with errors the current selection will be lost
	// remoteAction();

	// Bind handler for custom event
	// @ts-ignore
	$elem.on('mp-widget-reload.action-remote', throttledRemoteAction);

	// Add the change handler for inputs only
	if (elemType === 'INPUT') {
		$elem.on('change.action-remote, input.action-remote', throttledRemoteAction);
	}
};

/**
 * @param {string} eventName
 * @param {JQuery<HTMLElement>} $elem
 * @param {any} data
 */
const handleOnEvent = (eventName, $elem, data) => {

	const actions = [];

	for (const [actionName, actionData = {}] of Object.entries(data)) {

		switch (actionName) {

			// Set the value of other elements
			case 'setFields':
			case 'appendFields': {

				for (const [fieldId, field] of Object.entries(actionData)) {

					actions.push((e) => {
						const $field = $(`#${fieldId}`);
						let val;
						let triggerChange = false;

						// Set multiple options
						if (field && typeof field === 'object') {
							// Set value from other field
							if (field.element) {
								const $el = $(field.element);
								val = $el.is('input,select,textarea') ? $el.val() : nl2br($el.text());
							}
							// Dynamic value from other sources
							else if (field.useValue) {
								const { useValue } = field;

								// Send value of the triggering element
								if (useValue === 'self') {
									val = $elem.val();
								}
								// Send value passed through the event detail
								else if (useValue === 'eventDetail') {
									val = e.originalEvent.detail;
								}
								// Invalid
								else {
									console.warn('Incorrect `useValue` provided: %o (element: %o)', useValue, $elem[0]);
								}
							}
							// Set hardcoded value
							else if (field.value) {
								val = field.value;
							}
							// Also trigger change
							if (field.triggerChange === true) {
								triggerChange = true;
							}
						}
						// Set hardcoded value
						else {
							val = field;
						}

						if (typeof val !== 'undefined') {
							setFieldValue($field, val, actionName === 'appendFields', triggerChange);
						}
						else {
							console.warn('No setFields for %o', $field[0]);
						}

						// Return action name for debugging
						return actionName;
					});
				}

				break;
			}

			// Set element data
			case 'setData': {

				if (!Array.isArray(actionData)) {
					console.warn('Expected data-on-change.setData to be Array');
				}
				else {
					let i = -1;
					for (const info of actionData) {
						++i;

						if (!Array.isArray(info)) {
							console.warn(`Expected data-on-change.setData[${i}] to be Array`);
							continue;
						}

						const [element, data] = info;

						if (!element || (typeof element !== 'string')) {
							console.warn(`Expected data-on-change.setData[${i}][0] to be string`);
							continue;
						}
						if (!data || (typeof data !== 'object') || Array.isArray(data)) {
							console.warn(`Expected data-on-change.setData[${i}][1] to be hash`);
							continue;
						}
						console.log('Adding setData event on %o with data: %o', this, data);

						actions.push(() => {
							$elem.data(Object.fromEntries(Object.entries(data).map(v => [v[0], $(`#${v[1]}`).val()])));
							console.log('Set data for %o with data: %o', $elem[0], $elem.data());

							// Return action name for debugging
							return actionName;
						});
					}
				}

				break;
			}

			// Set element url
			case 'setUrl': {

				actions.push(() => {

					// Get the url from current data (not the cached actionData)
					const info = data.setUrl;

					/** @type {JQuery} */
					let $targetElement;
					/** @type {string} */
					let url;
					/** @type {[string, string][]} */
					let params;
					/** @type {string} */
					let mode = 'append';
					let originalUrl;

					// Hardcoded url
					if (typeof info === 'string') {

						// Use current element
						$targetElement = $elem;
						url = info;
					}
					// Object info
					else {

						// Set mode
						if (info.mode) {
							// eslint-disable-next-line prefer-destructuring
							mode = info.mode;
						}

						// Hardcoded url
						if (info.url) {
							// eslint-disable-next-line prefer-destructuring
							url = info.url;
						}

						// Hardcoded params
						if (info.params) {
							params = Array.isArray(info.params) ? info.params : [...(new URLSearchParams(info.params))];
						}

						// Get params from element
						if (info.url_from || info.params_from) {

							/** @type {JQuery<HTMLElement & HTMLFormElement & HTMLInputElement>} */
							const $fromElement = $(info.url_from || info.params_from);
							const fromType = $fromElement[0]?.tagName;

							// Form elements
							if ((fromType === 'INPUT') || (fromType === 'SELECT') || (fromType === 'TEXTAREA') || (fromType === 'FORM')) {

								/** @type {[string, string][]} */
								const tmpParams = $fromElement.serializeArray().filter(v => Boolean(v.value)).map(v => [v.name, v.value]);
								params = params ? [...params, ...tmpParams] : tmpParams;

								// Get full url from element
								if (info.url_from) {
									let action;

									if (fromType === 'FORM') {
										action = $fromElement.attr('action');
									}
									else {
										action = $fromElement[0].form ? $fromElement[0].form.action : $fromElement.closest('form').attr('action');
									}

									// Build the final url
									const urlObj = new URL(action, document.URL);
									// Append params
									for (const [name, value] of params) {
										urlObj.searchParams.append(name, value);
									}

									url = urlObj.toString();
									params = null;
								}
							}
							// Href or data-url/data-href attribute
							else {

								const nonFormElement = $fromElement[0];
								const { dataset } = nonFormElement;

								// Check data-url
								if (dataset.url) {
									url = $fromElement.data('url');
								}
								// Check data-href
								else if (dataset.href) {
									url = $fromElement.data('href');
								}
								// Check href
								else if (nonFormElement.hasAttribute('href')) {
									url = $fromElement.attr('href');
								}
								else {
									console.warn('No url found in %o', nonFormElement);
								}

								// Keep only the params
								if (info.params_from) {
									/** @type {[string, string][]} */
									const tmpParams = [...(new URL(url, document.URL)).searchParams];
									params = params ? [...params, ...tmpParams] : tmpParams;
									url = null;
								}
							}
						}

						$targetElement = (info.element)
							// Element selector provided
							? $(info.element)
							// Use current element
							: $elem;

						// Get url from element attributes or data
						if (!url) {
							originalUrl = getElementUrl($targetElement);
							// eslint-disable-next-line prefer-destructuring
							url = originalUrl.url;
						}

						if (!url) {
							console.warn('No viable attribute for settings target attribute found in %o', $targetElement[0]);
						}
					}

					// Set url
					if (url) {

						// Append url params only
						if (params) {

							const newUrl = new URL(url, document.URL);

							// Replace params
							if (mode === 'replace') {
								newUrl.search = '';
							}

							// Append new params
							for (const [name, value] of params) {
								// Params already exists and is not an array
								if (newUrl.searchParams.has(name) && !name.endsWith('[]')) {
									// Replace the param
									newUrl.searchParams.set(name, value);
								}
								// Append the param
								else {
									newUrl.searchParams.append(name, value);
								}
							}

							// Final url
							url = newUrl.toString();
						}

						// console.log('Set url to %o', url);

						// Set the new url
						setElementUrl($targetElement, url, originalUrl);
					}
					else {
						console.warn('Incorrect `setUrl` provided: %o (element: %o)', info, $elem[0]);
					}

					// Return action name for debugging
					return actionName;
				});

				break;
			}

			// Call user function
			case 'callFunction': {

				const fnName = actionData;
				actions.push(async () => {

					/** @type {function} */
					const fn = window[fnName] || mpro[fnName];

					try {
						await fn($elem.val(), $elem);
					}
					catch (error) {
						console.warn('Change handler[%o] error: %o', 'callFunction', error);
					}

					// Return action name for debugging
					return actionName;
				});

				break;
			}

			// Trigger event on other elements
			case 'trigger': {

				const triggerOpt = actionData;
				const eventName = triggerOpt.name;

				if (!eventName) {
					console.warn('Change handler[%o] error: %o', 'trigger', 'No event \'name\' provided');
				}
				else {

					actions.push(() => {

						let detail = triggerOpt.detail || null;
						const bubbles = ('bubbles' in triggerOpt) ? Boolean(triggerOpt.bubbles) : true;

						// Replace special keywords
						if (detail) {
							detail = decodeObjectKeywords(detail, $elem);
						}

						// Prepare the custom event
						const event = new CustomEvent(eventName, { bubbles, detail, cancelable: true });
						// @ts-ignore
						event.relatedTarget = $elem[0];
						const target = triggerOpt.target ? $(triggerOpt.target)[0] : $elem[0];

						if (target) {
							target.dispatchEvent(event);
						}
						else {
							console.warn('Change handler[%o] error: %o', 'trigger', 'Target does not exist: %o', triggerOpt.target);
						}

						// Return action name for debugging
						return actionName;
					});
				}

				break;
			}

			// Trigger the 'mp-load-fragment' event on elements
			case 'triggerLoadFragment': {

				/**
				 * @type {Omit<import('./mpro.sections.js').LoadFragmentOptions, 'container'> & { container?: true|string; }} options
				 */
				const options = (actionData === true) ? {} : actionData;
				if (!options.container) {
					options.container = true;
				}

				// Find the closest parent from the trigger $element
				const $container = (options.container === true)
					? $elem.closest('[data-load-fragment]')
					// Get by id
					: $(`#${options.container}`);

				if ($container.length === 0) {
					continue;
				}

				// Must delete the 'container' from options because it was processed above
				delete options.container;

				actions.push(() => {

					// Add the relatedTarget
					options.triggerElement = $elem;

					$container.triggerNative(new CustomEvent('mp-load-fragment', { detail: options, cancelable: false, bubbles: true }));
					// Return action name for debugging
					return actionName;
				});

				break;
			}

			// Submit form
			case 'submit': {

				const submitConf = typeof data.submit === 'object' ? data.submit : {};
				actions.push(() => {

					const {
						// Default to the parent form
						// @ts-ignore
						form = $elem[0].form || $elem.closest('form')[0],
						delay = 333,
						extraData,
					} = submitConf;

					submitForm(form, {
						extraData,
						state: data,
						triggerElement: $elem,
						delay,
					});
				});

				break;
			}

			// Trigger element reload
			case 'reloadWidgets': {

				/** @type {string[]} */
				const widgets = Array.isArray(actionData) ? actionData : [actionData];

				for (const widget of widgets) {
					const $widget = $(`#${widget}`);
					if ($widget.length === 0) {
						continue;
					}

					actions.push(() => {
						$widget.val(null)
							.trigger(new $.Event('mp-widget-reload'))
							// @ts-ignore (Trigger actually returns the chained collection, not void)
							.trigger('change');

						// Return action name for debugging
						return actionName;
					});
				}

				break;
			}

			// Reload section
			case 'updateSections':
			case 'reloadSections': {

				const { sectionIds, url } = actionData;
				const dataParents = actionData.dataParents ? [actionData.dataParents].flat() : null;

				// debugger;
				if (!sectionIds) {
					return;
				}

				/** @type {string[]} */
				const sections = Array.isArray(sectionIds) ? sectionIds : [sectionIds];

				actions.push(() => {
					const $form = $elem.closest('form');
					const $submit = $form.find('button:not([type="button"],[type="reset"])');
					// eslint-disable-next-line unicorn/no-array-reduce
					const $dataElements = dataParents ? dataParents.reduce((all, v) => all.add($(v)), $()).find('input,select,textarea,button').not(':disabled,[name=""]') : $form;

					$submit.prop('disabled', true);
					try {
						mpro.sectionReloadDelayed(sections, { url, data: $dataElements.serialize() });
					}
					finally {
						$submit.prop('disabled', false);
					}

					// Return action name for debugging
					return actionName;
				});

				break;
			}

			// Execute remote action
			// TODO
			// case 'remoteAction': {

			// 	actions.push(() => {
			// 		const rAction = RemoteAction.create($elem, {
			// 			...actionData,
			// 		});

			// 		console.log('rAction', rAction, 'constructor', rAction.constructor);

			// 		debugger;

			// 		// Return action name for debugging
			// 		return actionName;
			// 	});

			// 	break;
			// }

			// Randomize the order of the children of the given container
			case 'shuffleChildren': {

				/** @type {(string|boolean)[]} */
				const containers = Array.isArray(actionData) ? actionData : [actionData];

				for (const container of containers) {

					actions.push(() => {

						// Find the closest parent from the trigger $element
						const $container = $(`${container}`);

						if ($container.length === 0) {
							console.warn('[action/shuffleChildren]: No container found for selector: %o', container);
						}
						else {
							$container.shuffleChildren();
						}

						// Return action name for debugging
						return actionName;
					});
				}

				break;
			}

			// Dismiss components (drawer/modal/tooltip/toast)
			case 'dismiss': {

				if (typeof data.dismiss === 'string') {
					actions.push(() => {
						switch (data.dismiss) {
							case 'drawer':
							case 'offcanvas': {
								mpro.closeDrawer();
								break;
							}

							case 'modal': {
								mpro.closeModal();
								break;
							}

							case 'toast': {
								mpro.closeToast();
								break;
							}

							// Dismiss all
							default: {
								mpro.closeAllOverlays();
							}
						}

						// Return action name for debugging
						return actionName;
					});
				}

				break;
			}

			default: {
				console.warn('Invalid action: %o', actionName);
			}
		}
	}

	// Attach the change handler
	$elem.on(`${eventName}.action-on-${eventName}`, async (e) => {
		for (const action of actions) {
			// eslint-disable-next-line no-await-in-loop
			/* const actionName = */ await action(e);
			// console.log('elem: %o, res: %o', $elem[0], actionName);
		}
	});
};

/**
 * @param {JQuery.ClickEvent} e
 */
const handleClickActivateRow = (e) => {
	e.preventDefault();

	const $trigger = $(e.target);
	const $target = $trigger.next();

	$trigger.fadeOut(0);
	$target.show('fast').find('input,select,textarea').prop('disabled', false);
};

/**
 * Process special actions bound on form or form elements
 *
 * @param {JQuery<HTMLElement>|HTMLElement} container
 *
 * @returns {void}
 */
mpro.handleFormActions = (container) => {

	/** @type {JQuery} */
	// @ts-ignore
	const $container = (container instanceof $) ? container : $(container);
	const $formElements = $container.find('input,textarea,select');

	// Allow de-selecting radio inputs
	for (const input of $formElements.filter('input[type="radio"][data-allow-uncheck]')) {

		/** @type {JQuery<HTMLInputElement>} */
		// @ts-ignore
		const $input = $(input);
		let data = $input.data();
		if (!data) {
			data = {};
			$input.data(data);
		}

		/** @type {JQuery<HTMLLabelElement>} */
		// @ts-ignore
		let $label = $input.closest('label');
		if (input.id) {
			$label = $label.add($input.closest('form').find(`label[for="${input.id}"]`));
		}

		// Use the mouseup event to save the 'checked' prop (the click event already has this processed)
		$input.on('mouseup.allow-uncheck', (e) => {

			// @ts-ignore
			if (input.checked) {
				// Pass uncheck instruction to the click handler (which is executed after the mouseup handler)
				data.__doUncheck = true;
			}
		});

		// Also treat label clicks
		$label.on('click.allow-uncheck', (e) => {

			// @ts-ignore
			if (input.checked) {
				// Pass uncheck instruction to the click handler (which is executed after the mouseup handler)
				data.__doUncheck = true;
			}
		});

		// Use the click handler to do the uncheck in a hacky way
		$input.on('click.allow-uncheck', (e) => {

			// Check uncheck instruction sent from the mouseup handler (this is necessary because the browser sets the "checked=true" prop natively somewhere between 'mouseup' and 'click' events)
			if (data.__doUncheck === true) {
				data.__doUncheck = false;
				// @ts-ignore
				input.checked = false;
				// Manually trigger both 'input' and 'change' events, same as when the browser does it natively
				triggerEvent(input, 'input', { bubbles: true });
				triggerEvent(input, 'change', { bubbles: true });
			}
		});
	}

	// Auto-populate select from remote
	for (const select of $formElements.filter('select[data-remote-url]')) {
		// @ts-ignore
		handleSelectRemote(select);
	}

	// Auto-populate input from remote
	for (const input of $formElements.filter('input[data-remote-url]')) {
		// @ts-ignore
		handleInputRemote(input);
	}

	// Bind the change events to hide/show other fields (the 'toggle_widgets_handler' option from the backend)
	// Note: this must come BEFORE the widgets that have the [data-on-change]
	// for (const element of processFormChangeWidgets($container.find('[data-change-handler]'))) {
	// 	handleFormChangeWidgets(element);
	// }
	for (const element of $container.find('[data-change-handler]')) {
		const $elem = $(element);
		formWidgetsChangeHandler($elem, $elem.data('change-handler') || {});
	}

	const $onClickTargets = $container.find('a,button,input[type="button"],.on-click-action');

	// Bind the click event for various predefined actions
	for (const element of $onClickTargets.filter('[data-on-click]')) {
		const $elem = $(element);
		const data = $elem.data('on-click');
		handleOnEvent('click', $elem, data || {});
	}

	const $onChangeTargets = $formElements.add($container.find('.on-change-action'));

	// Bind the change event for various predefined actions
	// Note: this must come AFTER the widgets that have the [data-change-handler]
	for (const element of $onChangeTargets.filter('[data-on-change]')) {
		const $elem = $(element);
		const data = $elem.data('on-change');
		handleOnEvent('change', $elem, data || {});
	}

	const $onEventTargets = $container.find('section,main').add($onClickTargets.add($onChangeTargets));

	// Event agnostic handlers
	for (const element of $onEventTargets.filter('[data-on-event]')) {
		const $elem = $(element);
		const eventsData = $elem.data('on-event');

		for (const eventType in eventsData) {
			if (Object.hasOwn(eventsData, eventType)) {
				handleOnEvent(eventType, $elem, eventsData[eventType] || {});
			}
		}
	}

	// Enable 'setFields' change action (must be the last 'change' handler in queue)
	for (const elem of $formElements) {
		handleSetFieldsChange(elem);
	}

	// Bind the click event on triggers to activate rows
	const $activateButton = $container.find('[data-activate-row]');
	// @ts-ignore
	$activateButton.on('click.activate-row', handleClickActivateRow);
	// Disable inputs to prevent autocomplete trigger
	$activateButton.siblings().find('input,select,textarea').prop('disabled', true);

	// TODO
	// $container.find('[data-replace-url]').each(function () {

	// 	const $container = $(this);
	// 	const data = $container.data();
	// 	const url = data.replaceUrl;

	// 	if (!url) {
	// 		console.warn('Missing data-replace-url value for element', this);
	// 		return;
	// 	}

	// 	// Find trigger elements
	// 	$container.find('input[type="checkbox"],input[type="radio"]').each(function () {

	// 		const $elem = $(this);

	// 		const remoteSubmit = async () => {

	// 			/** @type {JQuery<HTMLFormElement>} */
	// 			// @ts-ignore
	// 			const $form = $elem.closest('form');

	// 			await doFetch($form.attr('action'), {
	// 				method: $form.attr('method') || 'POST',
	// 				data: new FormData($form[0]),
	// 			})
	// 				.then(resp => {
	// 					const $parent = $form.parent();
	// 					$form.replaceWith(resp);
	// 					// Re-bind form actions
	// 					mpro.initStatics($parent);

	// 				})
	// 				.catch(err => {
	// 					console.warn(err);
	// 					mpro.toast('error', 'Something went wrong');
	// 				});
	// 		};

	// 		// Bind handler for custom event
	// 		// @ts-ignore
	// 		$elem.on('mp-replace.action-remote', remoteSubmit);
	// 	});
	// });

	/**
	 * @param {HTMLFormElement | HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement | HTMLDivElement} element
	 * @param {JQuery.TriggeredEvent} e
	 */
	const handleFormAjaxSubmit = async function handleFormAjaxSubmit(element, e) {

		const isForm = element.tagName === 'FORM';
		// const isGroup = element instanceof HTMLDivElement;
		/** @type {HTMLFormElement} */ // @ts-ignore
		const form = isForm ? element : element.closest('form') || element.form;
		/** @type {JQuery<HTMLFormElement>} */ // @ts-ignore
		const $form = $(form);
		const $element = $(element);
		// Merge with data from the event
		const dataset = $.extend({}, $element.data(), e.detail || {});
		const options = dataset.ajaxSubmit || {};
		// Make sure url is undefined if not provided (could be null, in which case null will be used)
		options.url = options.url || undefined;
		options.method = options.method || undefined;

		const {
			url = dataset.url || $form.attr('action') || document.URL,
			method = $form.attr('method') || 'GET',
			type,
			loader = false,
			animation = true,
			replaceContainer = true,
			emptyContainer = true,
			contentSelector = null,
			allowRestore = false,
			context = null,
			submitter = e.target,
			validate = false,
			timeout,
		} = options;

		let $context;

		// Select closest context
		if (context) {

			// One of the parents
			$context = $form.closest(context);

			// Somewhere else
			if ($context.length === 0) {
				$context = $(context);
			}

			// No context found
			if ($context.length === 0) {
				mpro.toast('error', `Invalid form submit context provided: "${context}"`);
				return void 0;
			}
			// Only one context is allowed
			else if ($context.length > 1) {
				$context = $context.first();
			}
		}
		// Use the form as the default context
		else {
			$context = $form;
		}

		// Save a reference to the context parent for later
		const $parent = $context.parent();

		// Get modal parent
		// TODO: replace with MpModal.SELECTOR / MpDrawer.SELECTOR
		// mpro.isInOverlay() or mpro.getOverlayContainer()
		const $overlayContainer = $parent.closest(`.${MpModal.NAME}, .${MpDrawer.NAME}`);
		const isInModal = ($overlayContainer.length > 0) && $overlayContainer.hasClass(MpModal.NAME);
		const isInDrawer = ($overlayContainer.length > 0) && $overlayContainer.hasClass(MpDrawer.NAME);

		// @ts-ignore
		const $trigger = (dataset.disableTrigger === true && e.relatedTarget) ? $(e.relatedTarget) : (dataset.disableTrigger ? $(dataset.disableTrigger) : null);
		const canDisableTrigger = $trigger && $trigger.length > 0;

		const submitUrl = new URL(url, document.URL);
		const $submitButtons = $form.find('input[type="submit"],button:not([type="button"],[type="reset"])');

		// Add the submitter to the URL
		if (!isForm) {
			submitUrl.searchParams.set('ajax_submitter', $(submitter).data('ajax-submitter') || $(submitter).prop('name'));
		}

		const disableTrigger = () => {
			if (canDisableTrigger) {
				mpro.addButtonLoading($trigger);
			}
			for (const button of $submitButtons) {
				mpro.disableSubmitButton($(button));
			}
		};
		const enableTrigger = () => {
			if (canDisableTrigger) {
				mpro.removeButtonLoading($trigger);
			}
			for (const button of $submitButtons) {
				mpro.restoreSubmitButton($(button));
			}
		};

		// Do a form validation before submitting
		// ? Note: the validation is not enabled by default because it might have already been handled by Parsley.js
		// ? in the submit event handler (which is triggered before this handler in most cases)
		// ? This flag is useful when submitting individual form elements (not the whole form)
		if (validate === true) {

			// Decide which element to validate (inputs, textareas, selects are validated on their own, forms are validated as a whole - including if the handler is bound on a button)
			const $validationContext = (isForm || ($element.is('input,textarea,select') === false)) ? $form : $element;

			// Check for Parsley.js
			if (typeof $validationContext.parsley === 'function') {
				disableTrigger();
				try {
					// Wait for the validation to finish (the response is irrelevant)
					await $validationContext.parsley().whenValidate(/* { force: true } */); // sending { force: true } will force validation even if the field is not required
				}
				catch {
					console.warn('Validation failed on context element', $validationContext);
					return void 0;
				}
				finally {
					enableTrigger();
				}
			}
			else {
				console.warn('Parsley.js is not available');
			}
		}

		const formData = new FormData(form);
		// @ts-ignore
		const eventSubmitter = e?.originalEvent?.submitter ?? e.submitter;

		// Add the submitter
		if (eventSubmitter && eventSubmitter.getAttribute('name')) {
			formData.append(eventSubmitter.getAttribute('name'), eventSubmitter.getAttribute('value'));
		}

		// Disable the trigger
		disableTrigger();

		try {
			// Load the partial content in place
			const partial = await loadPartial($context, {
				// Specify different request types, based on the context (the response content might be different)
				type: type || (isInModal ? 'modal-content' : (isInDrawer ? 'drawer-content' : 'fragment')),
				url: submitUrl,
				method,
				data: formData,
				loader,
				animation,
				emptyContainer,
				replaceContainer,
				contentSelector,
				restoreOriginal: (allowRestore === true),
				relatedTarget: $element,
				timeout,
			});

			// Trigger the 'mp-ajax-submit-success' event
			triggerSubmitNotifyEvent(partial.success ? 'success' : 'error', submitUrl, method, formData, $element[0], partial.response);

			// Got redirect location
			if (partial.location) {

				// Close everything
				mpro.closeAllOverlays();

				// Handle extra response fields using the standard handler
				return void handleRemoteResponse(partial);
			}
			else if (partial.isContentful() === false) {

				if (isInModal || isInDrawer) {
					const instance = isInModal ? MpModal.getInstance($overlayContainer) : MpDrawer.getInstance($overlayContainer);

					if (instance) {
						instance.hide();
					}
				}
			}
			// Received a partial response
			else if (partial.$content.length > 0) {
				// Send the 'mp-content-updated' event (modals/drawers listen to this event)
				partial.$content.trigger('mp-content-updated', [partial]);
			}

			// Handle extra response fields using the standard handler
			handleRemoteResponse(partial);
		}
		catch (error) {
			console.warn('Error submitting form: %o', error);
			mpro.handleRestoreSubmitButtons($form);

			// Reset the form
			if (isForm) {
				form.reset();
			}
			// Reset the element
			else {
				if ('defaultValue' in element) {
					element.value = element.defaultValue;
				}
			}

			// Trigger the 'mp-ajax-submit-error' event
			triggerSubmitNotifyEvent('error', submitUrl, method, formData, $element[0], error);
		}
		finally {
			// Enable the trigger
			enableTrigger();
		}

		return void 0;
	};

	/**
	 * Handle form ajax submission
	 */
	// @ts-ignore
	$container.find('form[data-ajax-submit]').on('submit.action-submit', /** @this {HTMLFormElement} */ function(e) {
		e.preventDefault();
		// @ts-ignore
		handleFormAjaxSubmit(this, e);
	});

	/**
	 * Handle button click ajax submission
	 */
	// @ts-ignore
	$container.find('button[data-ajax-submit],a[data-ajax-submit]').on('click.action-submit', /** @this {HTMLFormElement} */ function(e) {
		e.preventDefault();
		// @ts-ignore
		handleFormAjaxSubmit(this, e);
	});

	const $ajaxSubmitElements = $container.find('input[data-ajax-submit],select[data-ajax-submit],textarea[data-ajax-submit],div[data-ajax-submit],fieldset[data-ajax-submit]');
	for (const elem of $ajaxSubmitElements) {

		const $elem = $(elem);
		const $form = $elem.closest('form');

		let formData;
		if ($form.length > 0) {

			formData = $form.data();

			if (!formData._delayedSubmitHandler) {
				formData._delayedSubmitHandler = (e) => {
					// Some ajax submit is happening
					if (formData._hasPendingAjaxSubmit === true) {
						// console.log('Delaying form submit');
						e.preventDefault();
						formData._shouldDoManualSubmit = true;
					}
					else {
						console.log('Doing form submit without delay');
					}
				};

				$form
					.off('submit.delayed-action-submit', formData._delayedSubmitHandler)
					.on('submit.delayed-action-submit', formData._delayedSubmitHandler);
			}

			$elem.on('input.prevent-early-submit', (e) => {
				formData._hasPendingAjaxSubmit = true;
				// console.log('Preventing early submit');
			});

			// Prevent pressing Enter from submitting the form
			const elOpt = { ...$elem.data('ajax-submit') };

			if (elOpt.preventDefault === true) {
				$elem.on('keydown.prevent-early-submit', (e) => {
					if (e.key === 'Enter') {
						e.preventDefault();
					}
				});
			}
		}
		else {
			formData = {};
		}
	}

	/**
	 * Handle form/input/select/textarea/radio-or-checkbox-groups ajax submission
	 */
	// @ts-ignore
	$ajaxSubmitElements.on('change.action-submit', /** @this {HTMLInputElement|HTMLSelectElement|HTMLTextAreaElement} */ function(e) {

		const throttleTypes = ['range', 'number'];
		const throttleDelay = 433;
		const $this = $(this);
		const data = $this.data();

		if ($(e.target).is('.checkbox-list')) {
			return;
		}

		// Delay form submission until after handleFormAjaxSubmit is executed
		const $form = $this.closest('form');
		const formData = ($form.length > 0) ? $form.data() : {};

		const proxyFormAjaxSubmit = async () => {

			// Block form submission until after handleFormAjaxSubmit is executed
			formData._hasPendingAjaxSubmit = true;
			// console.log('Doing ajax submit');
			await handleFormAjaxSubmit(this, e);
			formData._hasPendingAjaxSubmit = false;
			// console.log('Done ajax submit');

			// Submit the form if it was blocked
			if (formData._shouldDoManualSubmit === true) {
				formData._shouldDoManualSubmit = false;
				// The form is still connected to the DOM
				if ($form[0].isConnected === true) {
					$form.trigger('submit');
				}
				// else {
				// 	// ? Note: this is the exact same message that the browser shows when trying to submit a disconnected form
				// 	console.warn('Form submission cancelled because the form is not connected');
				// }
			}
		};

		// @ts-ignore
		if (throttleTypes.includes(this.type)) {

			// Clear previous timer
			if (data._throttleTimer) {
				window.clearTimeout(data._throttleTimer);
				data._throttleTimer = null;
			}

			data._throttleTimer = window.setTimeout(proxyFormAjaxSubmit, throttleDelay, this, e);
		}
		else {
			proxyFormAjaxSubmit();
		}
	});
};

export default mpro;
